import axios from './axios.js'
import loading from './loading.js'
import options from './options'
import icons from './icons'
import e5Icons from './e5Icons'
import regs from './regs'
import store from '../store'
import qs from 'qs'
import URL from 'url'
import BMap from './BMap'
import LoadExportsJS from './LoadExportsJS'
import aTemplate from './aTemplate'
import ueditor135 from './ueditor135'
import DownloadTable from './DownloadTable'
import SensitiveWordsUtil from './SensitiveWordsUtil'
import EventUtil from './EventUtil'
import dealUrlError from './dealUrlError'
import versionDeploy from './versionDeploy'
import serviceLocation from './serviceLocation'
import formatTime from './formatTime'
import fetchRequest from './fetchRequest'
import cloneDeep from './cloneDeep/index'
import CustomLodash from './customLodash/index'
import StorageEnum from './Enum/StorageEnum'
/* 先放这里。。 */
String.prototype.replaceAll = function (s1, s2) {
  return this.replace(new RegExp(s1, 'gm'), s2)
}

/**
 * 解密url字符串
 * @param url
 * @returns {*}
 */
function decryptUrl(url) {
  if (url.indexOf('customEncryptApiName') === 0) {
    // 以customEncryptApiName为开头，表明是经过加密后的url
    // 移除字符串标识符
    url = url.replace('customEncryptApiName', '')
    // 获取参数所在字符串索引位置
    let paramsIndex = url.slice(0, url.indexOf('/'))
    let paramsStr = ''
    // 移除自定义添加的前缀
    url = url.slice(url.indexOf('/') + 1)
    if (Number(paramsIndex) > -1) {
      paramsStr = url.slice(Number(paramsIndex))
      // 表明存在参数，需要截取参数
      url = url.slice(0, paramsIndex)
    }

    return (
      url
        .split('')
        .map((item) => item.charCodeAt(0) - 1)
        .map((item) => String.fromCharCode(item))
        .join('') + paramsStr
    )
  }
  return url
}
/**
 * 创建异步请求
 * @param url           除base url外的部分
 * @param method        method: get, post, delete, input
 * @param config        参数相关
 * @param vconfig       我们自定义配置 { neverLoading:是否不需要loading }
 */
const createAPI = (url, method, config, vconfig = {}) => {
  url = decryptUrl(url)
  config = config || {}
  if(method.toUpperCase() === 'GET'){
    // get请求参数编码
  }
  /* request Header */
  // e5
  if (
    config.params &&
    config.params.path &&
    config.params.path.indexOf(StorageEnum.ATTACHMENT) > -1
  ) {
    config.timeout = 60000
  }
  if (url === '/v1/newsedit/articles/forward') {
    config.timeout = 60000
  }
  let e5namespace = (vconfig && vconfig.e5namespace) || 'e5'
  let e5headers = {
    'base-param': JSON.stringify(store.state[e5namespace].metadata)
  }
  // get params 重新序列化一下
  config.paramsSerializer = function (params) {
    let queryparams = []
    for (let key in params) {
      if (typeof params[key] === 'object') {
        queryparams.push(key + '=' + encodeURIComponent(JSON.stringify(params[key])))
      } else {
        queryparams.push(key + '=' + encodeURIComponent(params[key]))
      }
    }
    // 会员管理部分接口参数是直接作为变量拼在在url上---'/prodb/baas-message/sender/v1/{id}/status/{status}/{num}'
    if (config.params && config.pathParams) {
      queryparams = []
    }
    return queryparams.join('&')
  }
  // 线索发现
  let clueDigHeaders = {}
  if (vconfig && vconfig.isClueDig && process.env.NODE_ENV === 'development') {
    clueDigHeaders = {
      token: 'f93e7ee229f83d43f3', // 通过token申请接口得到的AccessToken
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    if (method && method.toLowerCase() === 'post') {
      config.data = qs.stringify(config.data)
    }
  }
  config.headers
    ? (config.headers = {
        ...e5headers,
        ...clueDigHeaders,
        ...config.headers
      })
    : (config.headers = {
        ...e5headers,
        ...clueDigHeaders
      })
  // if (process.env.NODE_ENV === 'development') {
  //   if (url !== '/e5login/e5/login') {
  //     config.headers.authToken = localStorage.getItem('authToken')
  //     // config.headers['base-client-ip'] = '122.22.22.22'
  //     config.headers['base-client-ip'] = '127.0.0.1'
  //   }
  // }
  if (url !== '/e5login/e5/login') {
    const authToken = localStorage.getItem('authToken')
    if (authToken) {
      // authToken后端没有用，去掉
      // config.headers.authToken = authToken
    }
    if (url.startsWith('/prodb/member/spc/v1/')) {
      // 会员专用请求头
      // 记录会员管理日志的操作人
      let operatorName = encodeURIComponent(
        JSON.parse(localStorage.getItem('loginInfo') || '{}').userName
      )
      config.headers.operatorName = operatorName
      document.cookie = `sysUser=${operatorName}`
    }
    // config.headers['base-client-ip'] = '122.22.22.22'
    // config.headers['base-client-ip'] = '127.0.0.1'
  }
  if (config.originDomain && url.indexOf('http') !== 0) {
    url = config.originDomain + url
  }
  // 兼容多租户（可用稿件签发/转签相关接口验证
  if (config.headers && config.headers.tenantCode) {
    url = '/mediax-open/local-' + config.headers.tenantCode + url
  } else if (config.headers && config.headers.remoteMediaxCode) {
    url = '/mediax-open' + url
    if (config.params) {
      config.params.remoteChannel = config.headers.remoteMediaxCode
    }
    delete config.headers['remoteMediaxCode']
  }

  if (config.sourceEvent) {
    config.url = url
    config.method = method
    config = axios.requestInterceptor(config)
    if (method.toUpperCase() === 'GET' && config.params) {
      const query = new URLSearchParams(config.params).toString()
      url += (url.includes('?') ? '&' : '?') + query
    }
    if (method.toUpperCase() === 'POST' && config.data) {
      config.body = JSON.stringify(config.data)
    }
    return fetchRequest(
      url,
      {
        method,
        ...config
      },
      {
        controller: config.controller || null,
        timeout: config.timeout || null
      }
    ).then((res) => {
      if (!res.ok) {
        return axios.responseErrorHandler({
          response: res,
          config,
          vconfig
        })
      } else {
        return res
      }
    })
  } else {
    /* END request Header */
    // 拼接路径参数 参数直接/type拼在url上
    if (config.pathParams) {
      for (const key in config.pathParams) {
        url = url.replace(`{${key}}`, config.pathParams[key])
      }
    }
    return axios({
      url,
      method,
      ...config,
      vconfig
    })
  }
}

/**
 * 退出登录，清理数据
 */
function LogoutSystem(paramStr) {
  window.localStorage.removeItem('yqSystemTime')
  window.localStorage.removeItem('loginInfo')
  window.localStorage.removeItem('rrLoginUserInfo')
  window.localStorage.removeItem('tianmuyun')
  window.localStorage.removeItem('yqDefaultLogin')
  window.localStorage.removeItem('lastSeenMessageId') // 退出登录清空全局消息弹窗记录
  window.location.href = '/login' + (paramStr || '')
}
export {
  axios,
  URL,
  createAPI,
  loading,
  options,
  icons,
  e5Icons,
  regs,
  BMap,
  aTemplate,
  ueditor135,
  DownloadTable,
  SensitiveWordsUtil,
  EventUtil,
  dealUrlError,
  versionDeploy,
  serviceLocation,
  LoadExportsJS,
  decryptUrl,
  formatTime,
  LogoutSystem,
  cloneDeep, // 深克隆
  CustomLodash // 自定义lodash
}
